import React, { useEffect, useState } from "react"
import PropTypes from "prop-types"

/**
 * Renders an image with a static fallback when src is missing or fails to load.
 */
const MediaFallbackImage = ({
  src,
  fallback,
  alt = "",
  className = "",
  ...rest
}) => {
  const [failed, setFailed] = useState(false)
  const resolved = src && !failed ? src : fallback

  useEffect(() => {
    setFailed(false)
  }, [src])

  return (
    <img
      src={resolved || fallback}
      alt={alt}
      className={className}
      onError={() => {
        if (!failed) setFailed(true)
      }}
      {...rest}
    />
  )
}

MediaFallbackImage.propTypes = {
  src: PropTypes.string,
  fallback: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired,
  alt: PropTypes.string,
  className: PropTypes.string,
}

export default MediaFallbackImage
